export function formatPrice(number) {
    return Math.round(number)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
